import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = (): null => {
	// `key` changes on every navigation — including clicking a link to the page
	// you're already on (e.g. "Home" while scrolled down on Home), which
	// `pathname` alone would miss. This makes any nav link scroll back to top.
	const { key } = useLocation();
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [key]);
	return null;
};
